import cellRenderer from './cellRenderer'
import cellStyle from './cellStyle'
import { ICellRendererParams, EditableCallbackParams } from 'ag-grid-community'
import { memo } from 'react'

// 軽量なインラインSVGアイコン（MUI CreateRoundedIconの代替）
// MUIアイコンは内部に複数のDOM要素を生成するため、パフォーマンスに影響
export const EditableIcon = memo(() => (
  <svg
    className="editable-icon"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
))

export const FloatingEditableIcon = memo(function FloatingEditableIcon(
  params: ICellRendererParams
) {
  const editable = params.colDef?.editable
  const isEditable =
    typeof editable === 'function'
      ? editable(params as EditableCallbackParams)
      : !!editable
  if (!isEditable) return null
  return <EditableIcon />
})

export default {
  cellRenderer,
  cellStyle,
}
